export default "__VITE_ASSET__g8Xfy6Mw__"